import SubcategoryPage from '@/components/template/SubcategoryPage';

const Arya = () => {
  const products = [
    {
      title: "Arya Classic",
      imageSrc: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&q=80",
      url: "/proizvodi/arya-classic"
    },
    {
      title: "Arya Modern",
      imageSrc: "https://images.unsplash.com/photo-1584458313453-5589fcbb6233?auto=format&fit=crop&q=80",
      url: "/proizvodi/arya-modern"
    },
    {
      title: "Arya Premium",
      imageSrc: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/arya-premium"
    },
    {
      title: "Arya Deluxe",
      imageSrc: "https://images.unsplash.com/photo-1597696929736-6d13bed8e6a8?auto=format&fit=crop&q=80",
      url: "/proizvodi/arya-deluxe"
    },
    {
      title: "Arya Minimal",
      imageSrc: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&q=80&w=1300",
      url: "/proizvodi/arya-minimal"
    },
    {
      title: "Arya Natural",
      imageSrc: "https://images.unsplash.com/photo-1584458313453-5589fcbb6233?auto=format&fit=crop&q=80&w=1300",
      url: "/proizvodi/arya-natural"
    }
  ];

  return (
    <SubcategoryPage
      title="Arya"
      description="Elegantni in minimalistični Arya izdelki, ki prinašajo harmonijo v vaš prostor."
      heroImage="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Arya;